import { propertyType, t } from '@blocksuite/data-view';
import zod from 'zod';

export const createdByColumnType = propertyType('created-by');
export const createdByPropertyModelConfig = createdByColumnType.modelConfig({
  name: 'Created By',
  propertyData: {
    schema: zod.object({}),
    default: () => ({}),
  },
  jsonValue: {
    schema: zod.string().nullable(),
    type: () => t.string.instance(),
    isEmpty: ({ value }) => !value,
  },
  rawValue: {
    schema: zod.string().nullable(),
    default: () => null,
    toString: ({ value }) => value ?? '',
    fromString: ({ value }) => {
      return { value };
    },
    toJson: ({ value }) => value,
    setValue: () => {},
  },
  fixed: {
    defaultData: {},
    defaultShow: false,
  },
});
